export default __webpack_public_path__ + "static/media/main-background.2ef68b38.png";